var Footer = /** @class */ (function () {
    function Footer() {
        this.footer = document.querySelector('footer');
        this.footerNewsletterContainer = this.footer.querySelector('.newsletter-footer');
        this.footerNewsletterInput = this.footerNewsletterContainer.querySelector('.gfield input');
        if (this.footerNewsletterContainer && this.footerNewsletterInput) {
            this.addEventListeners();
        }
    }
    Footer.prototype.addEventListeners = function () {
        this.footerNewsletterInput.addEventListener('input', this.inputListener.bind(this));
    };
    Footer.prototype.inputListener = function (event) {
        var currentInput = event.currentTarget;
        var label = this.footerNewsletterContainer.querySelector('label');
        if (currentInput.value.trim() === '') {
            label.classList.remove('active');
        }
        else {
            label.classList.add('active');
        }
    };
    return Footer;
}());
export default Footer;
